class OverviewFilter {
  constructor(node) {
    this.element = node;

    this.datepickerInput = this.element.querySelector(".js-overview-filter-datepicker");
    this.sortInput = this.element.querySelector(".js-overview-filter-sort");
    this.searchInput = this.element.querySelector(".js-overview-filter-search");
    this.paginationWrapper = this.element.querySelector(".js-overview-filter-pagination");
    this.paginationBody = this.element.querySelector(".js-overview-filter-pagination-body");
    this.paginationElement = this.element.querySelector(".js-overview-filter-pagination-element");
    this.downloadButton = this.element.querySelector(".js-overview-filter-download-button");

    this.timeout;

    this.endpointUrl = new URL(this.paginationWrapper.dataset.url, window.location);
    this.currentUrl = new URL(window.location);

    if (this.downloadButton) {
      this.downloadButtonUrl = new URL(this.downloadButton.href, window.location);
    }

    this.initialize();
  }

  getAndSetAllParams() {
    this.currentUrl.searchParams.forEach((value, name) => {
      this.setSearchParams(name, value);
    });

    // incase we dont have the param param. set it to 1
    let currentPage = this.currentUrl.searchParams.get("page");

    if (currentPage == null) {
      this.setSearchParams("page", 1);
    }
  }

  setSearchParams(name, value, setHistory = true) {
    this.endpointUrl.searchParams.set(name, value);
    this.currentUrl.searchParams.set(name, value);

    if (this.downloadButton) {
      this.downloadButtonUrl.searchParams.set(name, value);

      this.downloadButton.href = this.downloadButtonUrl.href;
    }

    // TODO: add history API set state. (to utilise popstate)
    // if (setHistory) {
    //   window.history.replaceState({}, "", this.currentUrl);
    // }
  }

  handleFilterChange() {
    this.setSearchParams("page", 1); // Since we get new records we reset pagination.
    this.updatePaginationUrl();
  }

  initialize() {
    this.getAndSetAllParams();
    this.updatePaginationUrl();

    if (this.datepickerInput) {
      this.datepickerInput.addEventListener("datepicker-change", (e) => {
        const { name, value } = e.target;

        this.endpointUrl = new URL(this.paginationWrapper.dataset.url, window.location);

        if (this.downloadButton) {
          this.downloadButtonUrl = new URL(this.downloadButton.href, window.location);
        }

        this.setSearchParams(name, value);
        this.handleFilterChange();
      });
    }

    if (this.sortInput) {
      this.sortInput.addEventListener("change", (e) => {
        const { name, value } = e.target;

        this.endpointUrl = new URL(this.paginationWrapper.dataset.url, window.location);

        if (this.downloadButton) {
          this.downloadButtonUrl = new URL(this.downloadButton.href, window.location);
        }

        this.setSearchParams(name, value);
        this.handleFilterChange();
      });
    }

    if (this.searchInput) {
      this.searchInput.addEventListener("input", (e) => {
        const { name, value } = e.target;

        clearTimeout(this.timeout);

        this.timeout = setTimeout(() => {
          this.endpointUrl = new URL(this.paginationWrapper.dataset.url, window.location);

          if (this.downloadButton) {
            this.downloadButtonUrl = new URL(this.downloadButton.href, window.location);
          }

          this.setSearchParams(name, value);
          this.handleFilterChange();
        }, 500);
      });
    }

    this.paginationWrapper.addEventListener("pagination-link-clicked", (e) => {
      const { page } = e.detail;

      this.setSearchParams("page", page);
    });
  }

  updatePaginationUrl() {
    this.paginationWrapper.dataset.url = this.endpointUrl.href;

    this.paginationWrapper.dispatchEvent(new Event("pagination-link-updated"));
  }
}

const overviewFilter = document.querySelector("[data-js='overview-filter']");

if (overviewFilter) {
  new OverviewFilter(overviewFilter);
}
